import { render, staticRenderFns } from "./exameAnexo.vue?vue&type=template&id=d6207fc6&"
import script from "./exameAnexo.vue?vue&type=script&lang=js&"
export * from "./exameAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports